import { Alert } from 'react-bootstrap';
import { UserGroup } from '@nkr/enums/user-group';
import useOpoAdminSettings from '@nkr/store/opo/hooks/use-opo-admin-settings';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { SettingsPageWrapper } from '../styles';
import BillingSettings from './billing-settings';
import Agreements from './agreements';

const AdminSettingsContent = () => {
    const { settings, agreements, loading, error, save, uploadAgreement, downloadAgreement } = useOpoAdminSettings();

    if (loading) {
        return null;
    }

    return (
        <SettingsPageWrapper>
            {error && (
                <Alert bsStyle='danger'>{error}</Alert>
            )}

            {settings && (
                <BillingSettings settings={settings} onSave={save} />
            )}

            {settings && (
                <Agreements agreements={agreements} onUpload={uploadAgreement} onDownload={downloadAgreement} />
            )}
        </SettingsPageWrapper>
    );
}

const AdminSettings = () => {
    const { app } = useAppHookContext();

    if (app.user.groupId != UserGroup.Admin) {
        return <Alert bsStyle='warning'>These settings are only available to NKR administrators.</Alert>;
    }

    return <AdminSettingsContent />;
}

export default AdminSettings;
